import {
	autoinject,
	bindable,
	bindingMode,
	customElement,
} from 'aurelia-framework';

import styles from '~/components/field/common/base-checkbox/base-checkbox.module.scss';

@autoinject
@customElement('base-checkbox')
export class ViewCheckbox {
	/**
	 * styles is forwarding our styles to the *.html template
	 */
	private readonly styles = styles;

	private readonly iconClasses = styles['checkbox-icon'] + ' fa fa-check';

	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private name: string;

	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private label: string;

	/**
	 * To be used in conjunction with 'checked'. If you pass in
	 * an array. This 'model' value will be added/removed from the array
	 * passed in to the 'checked' property.
	 * See: https://aurelia.io/docs/binding/checkboxes#array-of-objects
	 */
	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private model: any;

	/**
	 * If boolean, simple toggles the value between true/false.
	 * If array, it adds/removes the 'model' value given to the array passed in.
	 * See: https://aurelia.io/docs/binding/checkboxes#array-of-objects
	 */
	@bindable({
		defaultBindingMode: bindingMode.twoWay,
	})
	private checked: any[] | boolean;

	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private disabled?: boolean;

	private constructor(private readonly element: Element) {}
}
